import { ArrowUpCircleIcon, ClockIcon, FireIcon, HeartIcon, SparklesIcon } from "@heroicons/react/24/solid";
import { CharacterService } from "@moe/priv/model/character";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { exploreCharactersQK } from "@web/route-services/index/Explore";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Route } from "@web/routes";
import { FaDice } from "react-icons/fa";

interface RankingOption {
  value: CharacterService.Ranking;
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export function RankingButtons() {
  const { ranking, searchText } = Route.useSearch();
  const { session } = useAppContext();
  const queryClient = useQueryClient();

  const rankingOptions: RankingOption[] = [
    // { value: "recommended", label: "For You", icon: SparklesIcon },
    { value: "message_count", label: "Top", icon: ArrowUpCircleIcon },
    { value: "recency", label: "New", icon: ClockIcon },
    { value: "hotness", label: "Hot", icon: FireIcon },
    { value: "random", label: "Random", icon: FaDice }
  ];
  if (session) rankingOptions.push({ value: "liked", label: "Liked", icon: HeartIcon });

  const renderRankingButton = ({ value, label, icon: Icon }: RankingOption) => (
    <Link
      key={value}
      to="/"
      onClick={() => {
        if (value === "random") {
          queryClient.invalidateQueries({ queryKey: [exploreCharactersQK] });
        }
      }}
      search={{ ranking: value, order: "desc", searchText, page: 1 }}
      className={`border-line flex items-center space-x-2 rounded-md border px-6 py-3 transition duration-200 ease-out active:brightness-95 ${
        ranking === value || (!ranking && value === "recommended")
          ? "bg-button-primary"
          : "bg-button-secondary hover:brightness-125"
      }`}
    >
      <Icon className="text-tx-primary -ml-1 size-6 shrink-0" />
      <span className="font-medium">{label}</span>
    </Link>
  );
  return <div className="flex flex-row space-x-2">{rankingOptions.map(renderRankingButton)}</div>;
}
